import { takeEvery, put } from 'redux-saga/effects';
import * as firebase from 'firebase';
import 'firebase/firestore';
import * as TYPES from '../Redux.actionTypes';
import _ from 'lodash';
import moment from 'moment';

import {
  setDisplayedWeek,
  setDisplayedMonth,
  setLoggedInDevoteeId,
  setIsAuthorized,
  setIsAuthenticated,
  setIsInitialLoading,
  setDevotionalGroupLeader,
  setSelectedDevotionalGroup,
} from '../Redux.actions.js';

function* initializeApp({ value }) {
  yield put(setIsAuthenticated(true));

  const devoteesRef = yield firebase.firestore().collection('devotees');
  const devotionalGroupsRef = yield firebase.firestore().collection('devotionalGroups');

  // Create a query against the collection.
  const query = yield devoteesRef.where('gmail', '==', value).get();

  // Use this line to log in as someone else by substituting their email
  // const query = yield devoteesRef.where('gmail', '==', 'frankscott99@gmail.com').get();
  const loggedInDevoteeId = _.get(query, `docs[0].id`);

  if (loggedInDevoteeId) {
    const loggedInDevoteeRef =
      yield firebase.firestore().collection('devotees').doc(loggedInDevoteeId);
    const loggedInDevoteeSnapshot = yield loggedInDevoteeRef.get();

    const isGroupLeader = loggedInDevoteeSnapshot.data().roles.devotionalGroupLeader;
    const isAdmin = loggedInDevoteeSnapshot.data().roles.admin;
    const hasEditPermission = loggedInDevoteeSnapshot.data().permissions.edit;

    // For group leaders, find the first group they're a leader of
    if (isGroupLeader) {
      const query = yield devotionalGroupsRef.where('leader', '==', loggedInDevoteeRef).get();
      const selectedDevotionalGroup = _.get(query, `docs[0]`);
      yield put(setSelectedDevotionalGroup(selectedDevotionalGroup.id));
    // If it's a devotee administrator, find their primary group
    } else if (isAdmin || hasEditPermission) {
      const selectedDevotionalGroup = loggedInDevoteeSnapshot.data().group;
      yield put(setSelectedDevotionalGroup(selectedDevotionalGroup.id));
    }

    yield put(setLoggedInDevoteeId(loggedInDevoteeId));
    yield put(setIsInitialLoading(false));
    yield put(setIsAuthorized(true));
  } else {
    yield put(setIsAuthorized(false));
    yield put(setIsInitialLoading(true));
  }

  // Set the week to display
  const mostRecentMonday = moment().startOf('isoWeek');
  yield put(setDisplayedWeek(mostRecentMonday));

  // Set the month to display
  const currentMonth = moment().month();
  yield put(setDisplayedMonth(currentMonth));

  // TODO: get the devotional group leader name through the user
  yield put(setDevotionalGroupLeader(`fc8fa879-4418-43bb-b81c-a51d98f2ea14`));
}

function* watchInitializeApp() {
  yield takeEvery(TYPES.INITIALIZE_APP, initializeApp);
}

export {
  watchInitializeApp,
  initializeApp,
}
